import { graphql } from "../../graphql";

export const NewsFeedFragment = graphql(`
  fragment NewsFeedFragment on FeedType @_unmask {
    id
    name
    image: logo @resize(width: 48, height: 48, sizer: CROP)
  }
`);
